<script setup>
import { computed } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import CallDispositionForm from './CallDispositionForm.vue';

// Modal wrapper pra finalização pós-chamada.
//
// Phase 2.9.10 Commit 1: modal desacoplado do CallRecord.
//   Antes: dependia de `getModalCallRecord` — se CallRecord nao chegou
//   do webhook a tempo, modal nunca abria.
//   Agora: consome `getModalContext` que carrega { callRecord, pendingCallEnd }.
//   Header, status e identificacao caem em fallback gracioso pro pendingCallEnd
//   (dados do SDK) enquanto CallRecord nao existe.

const store = useStore();
const { t } = useI18n();

// eslint-disable-next-line no-unused-vars
const _t = t;

const modalContext = computed(() => store.getters['voipDisposition/getModalContext']);
const callRecord   = computed(() => modalContext.value?.callRecord || null);
const pending      = computed(() => modalContext.value?.pendingCallEnd || null);

// Header displays — fallback: CallRecord real > pending do SDK.
const displayName = computed(() => {
  const c = callRecord.value;
  if (c?.contact?.name)  return c.contact.name;
  if (c?.peer_name)      return c.peer_name;
  if (pending.value?.peer_name) return pending.value.peer_name;
  return callRecord.value?.peer_phone || pending.value?.peer_phone || '';
});

const displayDuration = computed(() => {
  return callRecord.value?.duration_seconds ?? pending.value?.duration_seconds ?? 0;
});

const displayStatus = computed(() => {
  return callRecord.value?.final_status || pending.value?.final_status || '';
});

function handleDismiss() {
  store.dispatch('voipDisposition/hideModal');
}

function handleSaved() {
  // store ja fecha o modal via saveDispositionFromModal action
  store.dispatch('voipDisposition/hideModal');
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="modalContext"
      class="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm"
      @mousedown.self.prevent
    >
      <div class="w-full max-w-lg rounded-2xl bg-n-solid-1 border border-n-strong shadow-2xl flex flex-col max-h-[90vh] overflow-hidden">
        <!-- Header -->
        <header class="px-6 py-4 border-b border-n-weak">
          <h2 class="text-lg font-extrabold text-n-slate-12">
            {{ $t('VOIP_DISPOSITION.MODAL_TITLE') }}
          </h2>
          <p class="text-sm text-n-slate-11 mt-1">
            {{ displayName }} ·
            {{ displayDuration }}s ·
            <span class="capitalize">{{ displayStatus }}</span>
            <span v-if="!callRecord" class="ml-2 text-[10px] text-n-amber-11">
              (registro chega em instantes — preencher agora ja salva)
            </span>
          </p>
        </header>

        <!-- Body (scroll) -->
        <div class="px-6 py-4 overflow-y-auto flex-1 space-y-4">
          <!-- Form compartilhado com Avalie suas chamadas (DRY).
               Recebe callRecord + pendingCallEnd; quando callRecord e null,
               form usa pendingCallEnd pra mandar SDK data no save. -->
          <CallDispositionForm
            :call-record="callRecord"
            :pending-call-end="pending"
            :show-dismiss="true"
            @saved="handleSaved"
            @dismissed="handleDismiss"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>
